import React from "react";
import {
  Box,
  Center,
  HStack,
  Icon,
  VStack,
  Text,
  Image,
  useColorModeValue,
} from "@chakra-ui/react";
import { CameraIcon, ImageIcon, VideoCameraIcon } from "@phosphor-icons/react";

export type EventCardProps = {
  eventID: string;
  title: string;
  description: string;
  thumbnailUrl?: string;
  photoCount?: number;
  videoCount?: number;
  onClick?: () => void;
};

const EventCard: React.FC<EventCardProps> = ({
  eventID,
  title,
  description,
  thumbnailUrl,
  photoCount = 0,
  videoCount = 0,
  onClick,
}) => {
  const gray = useColorModeValue("gray.600", "gray.400");
  const bg = useColorModeValue("white", "gray.800");
  const hoverBg = useColorModeValue("gray.50", "transparent");
  const fallbackBg = useColorModeValue("gray.100", "gray.700");

  return (
    <Box
      id={eventID}
      borderWidth="1px"
      borderRadius="xl"
      w="full"
      overflow="hidden"
      bg={bg}
      boxShadow="sm"
      transition="0.3s ease"
      _hover={{
        bg: hoverBg,
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      {thumbnailUrl ? (
        <Image
          w="full"
          h="200px"
          src={thumbnailUrl}
          alt={title}
          objectFit="cover"
        />
      ) : (
        <Center w="full" h="200px" bg={fallbackBg}>
          <Icon as={ImageIcon} boxSize={12} color="gray.400" />
        </Center>
      )}

      <VStack align="start" spacing={3} p={4} w="full" justify="space-between">
        <VStack align="start" spacing={1}>
          <Text fontWeight="bold" fontSize="lg">
            {title}
          </Text>
          <Text fontSize="sm" color={gray} lineHeight="short">
            {description}
          </Text>
        </VStack>

        {/* Media stats */}
        <HStack spacing={{ base: 4, md: 6 }}>
          <HStack spacing={1}>
            <CameraIcon size={20} />
            <Text fontSize="sm" color={gray}>
              {photoCount}
            </Text>
          </HStack>
          <HStack spacing={1}>
            <VideoCameraIcon size={20} />
            <Text fontSize="sm" color={gray}>
              {videoCount}
            </Text>
          </HStack>
        </HStack>
      </VStack>
    </Box>
  );
};

export default EventCard;
